import { environmentHttpClientLayer } from "@afar-research/client-runtime/rpc";

import { primaryEnvironmentFetch } from "./fetch";

export function makePrimaryEnvironmentHttpLayer(
  fetchFn: typeof globalThis.fetch = globalThis.fetch,
) {
  return environmentHttpClientLayer((input, init) => primaryEnvironmentFetch(input, init, fetchFn));
}

export const primaryEnvironmentHttpLayer = makePrimaryEnvironmentHttpLayer();
